var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.article && _vm.article.content)?_c('div',{staticClass:"article-detail-wrapper",on:{"click":_vm.clicked}},[_c('v-runtime-template',{attrs:{"template":_vm.template}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }